import React from "react";

function Home() {
  return (
    <div className="serif">
      <p>Hi.</p>
      <p>
        This website is created to host all of my learning journal for LAJ2203
        “Japanese 4” at National University of Singapore.
      </p>
      <p>
        It was started at my professor's recommendation, and is now used to record
        all my thoughts after any lectures or tutorials in the module.
      </p>
      <p>
        They will be written into weeks. Incidents happening in one week will share
        one page, so tutorials and lectures within the same week will be written in
        the same post.
      </p>
      <p>You can find the list of all posts below.</p>
    </div>
  );
}

export default Home;
